import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './wptest.routes';
import ngMaterial from 'angular-material';
import WptestService from './wptest.service';
import WptestController from './wptest.controller';
export default angular.module('eeComUiApp.wptest', [uiRouter, ngMaterial])
    .config(routing)
    .service('WptestService', WptestService)
    .controller('WptestController', WptestController)
    .component('wptest', {
    template: require('./wptest.html'),
    controller: WptestController
})
    .name;
//# sourceMappingURL=index.js.map